<template>
	<!-- 资质申请 -->
	<!-- <div class="wrap">
			<div class="tabs">
				<div class="tabs_item" :class="{'isItem':isActive==0}" @click="checkItem(0)">单位申请记录</div>
				<div class="tabs_item" :class="{'isItem':isActive==1}" @click="checkItem(1)">行政文书发放记录</div>
			</div>
	</div> -->
	<div ref="tablePanel" class="wrap">
		<div class="tabs">
			<div class="tabs_item" :class="{'isItem':isActive==0}" @click="checkItem(0)">单位申请记录</div>
			<div class="tabs_item" :class="{'isItem':isActive==1}" @click="checkItem(1)">行政文书发放记录</div>
		</div>
		<div class="head-search" ref="headSearch">
			<div>
				<el-form ref="form" :model="form" label-width="90px">
					<el-form-item label="关键词：">
						<el-input v-model="form.keyWord" placeholder="请输入关键字"></el-input>
					</el-form-item>
					<el-form-item label="资质名称：">
						<el-select v-model="form.qualification" placeholder="请选择资质名称">
							<el-option label="全部资质" value="0"></el-option>
							<el-option label="资质一" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-button icon="el-icon-search" type="primary" class="btn btn-plus" style="margin-left: 32px;">
						搜索
					</el-button>
				</el-form>
			</div>
			<el-link type="primary" :underline="false">高级搜索 <i class="el-icon-d-arrow-right"></i> </el-link>

		</div>
		<div class="container">
			<div class="operation-btn" ref="operationBtn">
				<el-button icon="el-icon-upload" type="primary" class="btn btn-plus" @click="handleExport">
					导出
				</el-button>
				<el-button icon="el-icon-upload" type="primary" class="btn btn-plus" @click="handleHandover">
					导出交接单
				</el-button>
			</div>
			<div class="container-table">
				<el-table :style="{ height: `${tableMaxHeight}` + 'px' }" :max-height="tableMaxHeight" :data="tableData"
					stripe style="width: 100%" header-cell-class-name="tableHeaderCellClassName"
					header-row-class-name="tableHeaderRowClassName">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="name" label="单位名称" width="250"></el-table-column>
					<el-table-column prop="person" label="法人" width="120"></el-table-column>
					<el-table-column prop="type" label="单位性质" width="100"></el-table-column>
					<el-table-column prop="code" label="统一社会信用代码" width="200"></el-table-column>
					<el-table-column prop="time" label="成立时间" width="120" sortable></el-table-column>
					<el-table-column prop="address" label="单位办公地址" width="220"></el-table-column>
					<el-table-column prop="number" label="手机号码" width="150"></el-table-column>
					<el-table-column prop="contact" label="联系人" width="120"></el-table-column>
					<el-table-column label="操作">
						<template v-slot="{ row }">
							<el-link icon="el-icon-view" type="primary" :underline="false" class="cloumn-btn" @click="viewDetails">
								详情
							</el-link>
							<el-link icon="el-icon-search" type="primary" :underline="false" class="cloumn-btn" @click="openReview">
								审查
							</el-link>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="container-pagination" ref="containerPagination">
				<el-pagination background layout="prev, pager, next, sizes, jumper" :total="1000"></el-pagination>
			</div>
		</div>
		<exportDialog ref="exportDialog" />
		<handoverDialog ref="handoverDialog"></handoverDialog>
		<reviewDialog ref="reviewDialog"></reviewDialog>
	</div>
</template>

<script>
	import exportDialog from './components/exportDialog.vue'
	import handoverDialog from './components/handoverDialog.vue'
	import reviewDialog from './components/reviewDialog.vue'
	export default {
		components: {
		  exportDialog,
		  handoverDialog,
		  reviewDialog
		},
		data() {
			return {
				isActive: 0,
				tableMaxHeight: 400,
				tableData: [{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
					{
						name: '曜硕科技(上海)有限公司',
						person: '吴洁立',
						type: '私营企业',
						code: '230181991081407',
						time: '2022-09-06',
						address: '大红门服饰商贸城',
						number: '18335263645',
						contact: '孙子涵',
					},
				],
				form: {
					keyWord: '',
					qualification: ''
				}
			}
		},

		mounted() {
			this.calcTableHeight()
			this.$root.$on('resize', () => {
				this.calcTableHeight(500)
			})
			this.editElPaginationJumperText()
		},
		methods: {
			checkItem(val) {
				this.isActive = val
			},
			handleExport() {
				this.$refs.exportDialog.open()
			},
			openReview(){
				this.$refs.reviewDialog.open()
			},
			handleHandover() {
				this.$refs.handoverDialog.open()
			},
			handleEdit(row) {
				this.$refs.dialog.edit(row)
			},
			viewDetails() {
				this.$router.push({
					name: 'applyDetails'
				})
			},
			editElPaginationJumperText() {
				document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue =
					'跳至'
			},
			calcTableHeight(delay) {
				// 动态计算表格的高度，自适应当前容器,168是计算得出的margin和padding的距离
				setTimeout(() => {
					const tablePanelHeight = this.$refs.tablePanel.parentNode.clientHeight
					const headSearchHeight = this.$refs.headSearch.clientHeight
					const operationBtnHeight = this.$refs.operationBtn.clientHeight
					const containerPaginationHeight = this.$refs.containerPagination.clientHeight
					this.tableMaxHeight =
						tablePanelHeight -
						headSearchHeight -
						operationBtnHeight -
						containerPaginationHeight -
						195
				}, delay || 0)
			},
		},
	}
</script>

<style lang="less" scoped>
	/deep/ .el-table__row .cell {
		font-family: Microsoft YaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 19px;
		letter-spacing: 0px;
		color: #24262b;
	}

	/deep/ .el-checkbox__inner {
		width: 20px;
		height: 20px;
		background-color: #ffffff;
		border-radius: 4px;
		border: solid 2px #c4c4c4;
	}

	/deep/ .el-checkbox__inner::after {
		left: 6px;
		top: 2px;
	}

	/deep/ .el-pagination__jump {
		margin-left: 0;
	}

	.wrap {
		padding: 24px;
		box-sizing: border-box;

		.btn {
			height: 40px;
		}

		.btn-plus {
			background-color: #0147eb;
		}

		.tabs {
			display: flex;

			.tabs_item {
				margin-right: 30px;
				color: #9699a0;

			}

			.isItem {
				font-weight: bold;
				color: #0147eb !important;
			}
		}

		.head-search {
			width: 100%;
			height: 78px;
			background-color: #ffffff;
			box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
			border-radius: 16px;
			padding: 19px 24px;
			box-sizing: border-box;
			margin: 16px 0;
			display: flex;
			justify-content: space-between;

			/deep/.el-form-item {
				margin: 0;
				display: inline-block;
			}

			/deep/.el-input {
				width: 209px;
			}
		}

		.container {
			width: 100%;
			// height: 858px;
			background-color: #ffffff;
			box-shadow: 0px 12px 23px 0px rgba(0, 0, 0, 0.05);
			border-radius: 16px;
			padding: 24px;
			box-sizing: border-box;

			.operation-btn {
				margin-bottom: 24px;
			}

			.cloumn-btn {
				width: 76px;
				height: 32px;
			}
		}

		.container-pagination {
			display: flex;
			justify-content: end;
			margin-top: 26px;
		}
	}
</style>
